import { useEffect, useState } from 'react';
import Sidebar from '@common/Sidebar'
import Header from '@common/Header';
import BottomMenu from '@common/BottomMenu'
import Chat from '@common/Chat';
import classNames from "classnames";
import s from './Layout.css';
import { useIsMinimizedMenu } from '@/hooks/useIsMinimizedMenu';
import SupportChatButton from '@common/Chat/SupportChatButton/SupportChatButton';
import { ChatProvider } from '@common/Chat/ChatContext';
import { useChatState } from '@common/Chat/useChatState';
import useIsTechSupport from '@common/Chat/SupportChatButton/useIsTechSupport';
import { useSelector } from 'react-redux';

const Layout = ({ children }) => {
  const isMinimizedMenu = useIsMinimizedMenu();
  const chatState = useChatState();
  const { chatIsDisabledButTechnicalSupportIsEnabled } = useIsTechSupport()

  const isChatEnabled = useSelector(store => store.settings.isChatEnabled);
  const chatEnabled = isChatEnabled == '1'

  return (
    <ChatProvider changePage={chatState.changePage}>
      <div className={classNames('app-wrapper', {'app-wrapper-menu-minimized': isMinimizedMenu} , s.sideWrapper)} >
        <Sidebar />
        <Header />
        {children}
        <BottomMenu />
        <SupportChatButton />
        {(chatEnabled || chatIsDisabledButTechnicalSupportIsEnabled) && <Chat chatState={chatState} />}
      </div>
    </ChatProvider>
  )
}

export default Layout;
